// /src/components/ErrorBoundary.jsx
import React from 'react';
export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(err, info) { console.error('Boundary:', err, info); }
  render() {
    if (this.state.hasError) {
      return <div style={{ padding: 24 }}>⚠️ No se pudo cargar la página. Revisa rutas/archivos.</div>;
    }
    return this.props.children;
  }
}
